import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonGroup from 'apollo-react/components/ButtonGroup';

const TableActions = ({ actions, row }) => {
  const [t] = useTranslation();

  const btns = actions.map((action) => ({
    variant: action.color,
    status: action.status,
    label:
      action.text === 'Activate / Deactivate'
        ? row.active
          ? t('Deactivate')
          : t('Activate')
        : action.text === 'Publish / Activate / Deactivate'
          ? row.status === 'published_active'
            ? t('Deactivate')
            : row.status === 'published_deactivated'
              ? t('Activate')
              : row.status === 'not_published'
                ? t('Publish')
                : t('Publish')
          : t(action.text),
    icon: action.icon,
    onClick: () => action.onClick(row),
    style: {
      ...action.style,
      minHeight: '32px',
      fontSize: '14px',
      fontWeight: 400,
      fontFamily: 'Proxima Nova',
    },
    disabled:
      action.text === t('downloadAttachment')
        ? !row?.attachments?.length
        : action.disabled,
  }));

  return <ButtonGroup buttonProps={btns} />;
};

export default TableActions;
